import script from "./OrderStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderStatus.vue?vue&type=script&setup=true&lang=js"

import "./OrderStatus.vue?vue&type=style&index=0&id=20ea1776&scoped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ea1776"]])

export default __exports__